import {useCallback, useContext, useEffect, useRef, useState} from "react";
import {TranslationContext} from "@/Utils/TranslationProvider";

export const useTranslation = () => {
    const translations = useContext(TranslationContext);

    const t = useCallback(
        (key: string, fallback: string) => {
            if (translations?.showComponents) return key;
            if (translations?.translations && Object.keys(translations.translations).length) {
                return translations?.translations[key] ?? fallback;
            }
            return fallback;
        },
        [translations?.showComponents, translations]
    );

    const prefixLoaded = useCallback(
        (prefix) => {
            if (translations?.translations && Object.keys(translations?.translations).length > 0) {
                return Object.keys(translations?.translations).findIndex((key) => key.startsWith(prefix + ".")) != -1;
            }

            return false;
        },
        [translations]
    );

    const addTranslations = useCallback(
        (newTranslations) => {
            if (translations?.translations && Object.keys(translations?.translations).length > 0) {
                const temp = {};
                newTranslations?.translations?.forEach((translation) => {
                    temp[translation?.component] = translation.text;
                });

                translations?.setTranslations({...translations?.translations, ...temp});
            }
        },
        [translations]
    );

    return {t, translations, prefixLoaded, addTranslations};
};
